 import { useNavigate } from "react-router-dom";
 import { LogIn } from "lucide-react";
 import Button from "../components/ui/Button";

 export default function Unauthorized() {
   const navigate = useNavigate();

   return (
     <div className="flex flex-col items-center justify-center min-h-screen bg-secondary-950 text-gray-200 px-6 text-center">
       {/* Logo */}
       <img
         src="/logo192.png"
         alt="Kirtagames Logo"
         className="w-20 h-20 mb-6 animate-pulse"
       />

       {/* Titel */}
       <h1 className="text-3xl font-bold text-red-500 mb-2">
         Zugriff verweigert
       </h1>

       {/* Beschreibung */}
       <p className="text-gray-400 max-w-md mb-8">
         Du hast keine Berechtigung, diese Seite zu sehen.  
         Bitte melde dich mit einem Konto an, das die erforderliche Rolle hat.
       </p>

       {/* Aktionen */}
       <div className="flex flex-col sm:flex-row gap-3">
         <Button
           variant="primary"
           onClick={() => navigate("/login")}
           className="flex items-center justify-center gap-2"
         >
           <LogIn size={18} />
           Zum Login
         </Button>

         <Button
           variant="secondary"
           onClick={() => navigate(-1)}
           className="flex items-center justify-center gap-2"
         >
           Zurück
         </Button>
       </div>
     </div>
   );
 }
